<script>
export default {
  name: "setPermissions",
  data() {
    return {
      form: {},
      data: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1"
                },
                {
                  id: 10,
                  label: "三级 1-1-2"
                }
              ]
            }
          ]
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1"
            },
            {
              id: 6,
              label: "二级 2-2"
            }
          ]
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1"
            },
            {
              id: 8,
              label: "二级 3-2"
            }
          ]
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  methods: {
    // submit() {}
  }
};
</script>

<template>
  <!-- 整体表单  -->
  <el-form ref="form" :model="form" label-width="160px">
    <el-form-item label="功能权限" prop="userName">
      <el-card shadow="never">
        <el-tree
          :data="data"
          show-checkbox
          node-key="id"
          :default-expanded-keys="[2, 3]"
          :default-checked-keys="[5]"
          :props="defaultProps"
        >
        </el-tree
      ></el-card>
    </el-form-item>
    <el-form-item
      label="数据权限"
      prop="userPhone"
      :rules="[{ required: true, trigger: 'blur' }]"
    >
      <el-card shadow="never">
        <el-radio-group v-model="form.awardWay">
          <el-radio :label="0">全部数据</el-radio>
          <el-radio :label="1">所在团队数据</el-radio>
          <el-radio :label="2">个人数据</el-radio>
        </el-radio-group>
      </el-card>
    </el-form-item>
  </el-form>
</template>

<style scoped lang="scss">
::v-deep .el-card {
  width: fit-content !important;
  height: fit-content !important;
  padding: 0px !important ;
  .el-card__body {
    padding: 10px 20px;
    line-height: initial;
  }
}
</style>
